import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsightGroup, Priority } from '../../../models/college-dashboard.model';

@Component({
  selector: 'app-ai-insights',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ai-insights.component.html',
  styleUrl: './ai-insights.component.scss'
})
export class AiInsightsComponent {
  @Input() insightGroups: InsightGroup[] = [];

  get totalInsights(): number {
    return this.insightGroups.reduce((acc, g) => acc + g.students, 0);
  }

  getPriorityClass(priority: Priority): string {
    switch (priority) {
      case 'Critical':
        return 'critical';
      case 'High Priority':
        return 'high';
      case 'Medium Priority':
        return 'medium';
      case 'Low Priority':
        return 'low';
      default:
        return 'medium';
    }
  }
}
